var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Invalid Invoice"}},[_c('div',{staticClass:"vx-row"},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Trade"}},[_c('invoice-trade')],1),_c('vs-tab',{attrs:{"label":"Non Trade"}},[_c('div',{staticClass:"tab-text"},[_c('non-trade')],1)])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }